import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelOrderRegionEntity } from '../../domain/entities/ChannelOrderRegionEntity'
import type { ChannelOrderRegionAdminDto } from '@/backend/market'

export class ChannelOrderRegionModel extends ChannelOrderRegionEntity {
  constructor(dataDto: ChannelOrderRegionAdminDto) {
    super()
    mapEntityProperties<ChannelOrderRegionModel>(this, dataDto)
  }
}
